<template lang="html">
  <div>
    <v-container v-if="progressing">
      <v-row
        class="fill-height" 
        
        align="center" 
        justify="center"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-row>     
    </v-container>
    <material-chart-card
      v-else
      :data="chartData"
      :options="chartOptions"
      :event-handlers="eventHandlers"
      color="success"
      type="Bar"
    >
      <v-row>
        <v-col 
          cols="8" 
          class="pb-0"
        >
          <v-row>
            <v-col 
              cols="12" 
              class="pb-0"
            >
              <h4 class="title font-weight-light">
                Feedback / Target
              </h4>
            </v-col>
          </v-row>

          <v-row>
            <v-col 
              cols="12" 
              class="pt-0"
            >
              <p 
                v-if="getCurrentEmployee()" 
                class="category d-inline-flex font-weight-light"
              >
                <span 
                  v-if="getCurrentEmployee().optimalTarget > 0" 
                  class="green--text"
                >{{ getCurrentEmployee().subordinateActualSalesTotal > 0 ? 
                  100-(getCurrentEmployee().subordinateActualSalesTotal / getCurrentEmployee().optimalTarget *100).toFixed(0) : 
                  100-(getCurrentEmployee().selfActualSalesTotal / getCurrentEmployee().optimalTarget *100).toFixed(0)
                }}%</span>&nbsp;
                left to reach this month's optimal target
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col 
          cols="4" 
          class="pb-0"
        >
          <v-select
            v-model="selectedKpiType"
            hint
            :items="kpiTypes"
            placeholder="Search KPI Types"
            item-text="name"
            label="KPI Types"
            return-object
            @change="updateChartData"
          />
        </v-col>
      </v-row>
      <!-- {{ sumEmployeeTarget }} -->
      <template slot="actions">
        <v-icon
          class="mr-2"
          small
        >
          mdi-clock-outline
        </v-icon>
        <span class="caption grey--text font-weight-light">updated 0 minutes ago</span>

        <v-spacer />
        <user-feedback-dialog-edit
          @feedback-saved="feedbackUpdated()"
        />
      </template>
    </material-chart-card>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    components: {
      UserFeedbackDialogEdit: () => import('@/components/user/FeedbackDialogEdit'),
    },
    props: {
      employee: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        selectedKpiType: null,
        defaultChartData: [],
        progressing: false,
        kpiTypes: [],
        chartData: {
          labels: ['Feedback', 'Target', 'Actual Sales', 'Optimal Target'],
          series: [],
        },
        chartOptions: {
          distributeSeries: true,
          height: '200px',
          horizontalBars: true,
          axisX: {
            // onlyInteger: true,
            // ticks: [200, 1000, 100000],
            // type: this.$chartist.FixedScaleAxis,
            showLabel: false,
            labelInterpolationFnc: (value, index) => {
              return this.$options.filters.toCurrency(parseInt(value))
            },
          },
          chartPadding: {
            top: 10,
            right: 70,
            bottom: 30,
            left: 40,
          },
          plugins: [
            this.ctBarLabels(),
          ],
        },
        eventHandlers: [
          {
            event: 'draw',
            fn (data) {
              if (data.type === 'bar') {
                data.element.attr({
                  style: 'stroke-width: 25px',
                })
              }
            },          
          },
        ],
      }
    },
    computed: {    
      sumEmployeeTarget () {
        let data = _.cloneDeep(this.defaultChartData)

        data.forEach((employee) => {
          // total self target
          employee.selfTargetTotal = 0
          employee.selfActualSalesTotal = 0
          employee.subordinateTotal = 0
          employee.subordinateActualSalesTotal = 0
          employee.feedbackTotal = 0
        })
      
        data.forEach((employee) => {
          if (employee.kpi_target_feedback.length > 0) {
            let feedbacks = employee.kpi_target_feedback
              .filter((feedback) => {
                return feedback.kpi_category_id === this.selectedKpiType.id
              })

            if (feedbacks.length > 0) { // if has selected kind
              employee.feedbackTotal += feedbacks[0].value
              data = this.addFeedbackToParent(data, employee.report_to.assigned_to, feedbacks[0].value)
            }
          }

          if (employee.cro_performance.length > 0) { // has cro performance and reporting to someone
            employee.selfActualSalesTotal = employee.cro_performance.reduce((total, val) => total + val.net_capital_sales, 0)
          
            if (employee.report_to) {
              data = this.addSalesToParent(data, employee.report_to.assigned_to, employee.selfActualSalesTotal)
            }
          }

          if (employee.kpi_targets) { // sum up kpi targets
            let targets = employee.kpi_targets
              .filter((target) => {
                return target.kpi_category_id === this.selectedKpiType.id
              })

            if (targets.length > 0) {
              employee.selfTargetTotal = targets.reduce((total, val) => total + val.value, 0)
              // targets[0].value = 50000
              employee.optimalTarget = targets.slice(0, new Date().getMonth())
                .reduce((total, val) => total + val.value, 0)
            }
          } 
        })
        return data
      },
    },
    watch: {
      employee: {
        immediate: true,
        handler (value) {
          if (!_.isEmpty(value)) {
            this.$resetData()
            this.loadKpiChart()
          }
        },  
      }, 
    },
    methods: {
      loadKpiChart () {
        this.progressing = true
        this.$api.kpiCategories().list()
          .then((kpiTypes) => {
            this.kpiTypes = kpiTypes.data
            this.getInitialData()
          })
      },
      feedbackUpdated () {
        this.getInitialData()
      },
      ctBarLabels (options) {
        let defaultOptions = {
          // The class name so you can style the text
          labelClass: 'ct-bar-label',

          // Use this to get the text of the data and you can return your own
          // formatted text. For example, for a percentage: 
          // {
          //  labelInterpolationFnc: function (text) { return text + '%' }
          // }
          labelInterpolationFnc: this.$chartist.noop,

          // Depending on your font size you may need to tweak these
          labelOffset: {
            x: 0,
            y: 5,
          },

          // If labelOffset doesn't work for you and you need more custom positioning
          // you can use this. You can set position.x and position.y to functions and
          // instead of centering + labelOffset. This will _completely_ override the
          // built in positioning so labelOffset will no longer do anything. It will
          // pass the bar `data` back as the first param.
          //
          // Example:
          // Chartist.plugins.ctBarLabels({
          //   position: {
          //     x: function (data) {
          //       return data.x1 + 50; // align left with 50px of padding
          //     }
          //   }
          // });
          position: {
            x: null,
            y: null,
          },
        }

        options = this.$chartist.extend({}, defaultOptions, options)
    
        var positionX = options.position.x || function (data) {
          return ((data.x1 + data.x2) / 2) + options.labelOffset.x
        }

        var positionY = options.position.y || function (data) {
          return ((data.y1 + data.y2) / 2) + options.labelOffset.y
        }

        return function ctBarLabels (chart) {
          // Since it's specific to bars, verify its a bar chart
          // if (chart instanceof Chartist.Bar) {
          chart.on('draw', function (data) {
            // If the data we're drawing is the actual bar, let's add the text
            // inside of it
         
            if (data.type === 'bar') {
              if (data.series > 0) {
                let displayValue = 0
                if (data.value.x) {
                  var formatter = new Intl.NumberFormat('en-US', {
                    style: 'decimal',
                    minimumFractionDigits: 0,
                  })
                  displayValue = formatter.format(parseInt(data.value.x))
                }

                data.group.elem('text', {
                  // This gets the middle point of the bars and then adds the
                  // optional offset to them
                  x: positionX(data),
                  y: positionY(data),
                  style: 'text-anchor: middle',
                }, options.labelClass)
                  .text(
                    options.labelInterpolationFnc(
                      displayValue
                      // If there's not x (horizontal bars) there must be a y
                    // data.value.x || data.value.y
                    )
                  )
              }
            }
          })
        // }
        }
      },
      getChartXScale () {      
        let max = Math.max(...this.chartData.series)
        let baseNumber = max / 5

        let scale = ['0']
        for (let x = 1; x < 6; x++) {
          scale.push((x * baseNumber).toFixed(0))
        }
      
        return scale
      },
      addSalesToParent (data, parentUid, salesAmount) {
        data.forEach((employee) => {
          if (employee.employee_uid === parentUid) {
            employee.subordinateActualSalesTotal += salesAmount

            if (employee.report_to) {
              data = this.addSalesToParent(data, employee.report_to.assigned_to, salesAmount) 
            }
          }
        })

        return data
      },
      getCurrentEmployee () {
        let index = this.sumEmployeeTarget.findIndex((worker) => {
          return worker.employee_uid === this.employee.employee_uid
        })

        return this.sumEmployeeTarget[index]
      },
      updateChartData () {
        let currentEmployee = this.getCurrentEmployee()
        this.$set(this.chartData.series, '0', currentEmployee.feedbackTotal > 0 ? currentEmployee.feedbackTotal : 0)
        this.$set(this.chartData.series, '1', currentEmployee.selfTargetTotal > 0 ? currentEmployee.selfTargetTotal : 0)

        if (this.selectedKpiType.id === 1) { // actual sales only works for sales type
          this.$set(this.chartData.series, '2', currentEmployee.subordinateActualSalesTotal > 0 ? currentEmployee.subordinateActualSalesTotal : currentEmployee.selfActualSalesTotal)
        } else {
          this.$set(this.chartData.series, '2', 0)
        }

        this.$set(this.chartData.series, '3', currentEmployee.optimalTarget > 0 ? currentEmployee.optimalTarget : 0)
        this.chartOptions.axisX.ticks = this.getChartXScale()
        this.progressing = false
      },
      addFeedbackToParent (data, parentUid, feedbackAmount) {
        data.forEach((employee) => {
          if (employee.employee_uid === parentUid) {
            employee.feedbackTotal += feedbackAmount

            if (employee.report_to) {
              data = this.addFeedbackToParent(data, employee.report_to.assigned_to, feedbackAmount) 
            }
          }
        })

        return data
      },
      getInitialData () {
        this.$http.all([this.$api.kpiTarget().employeeOverview(), this.$api.kpiTarget().branchOverView()])
          .then(this.$http.spread((kpichart, branchKpi) => {
            kpichart.data.forEach((employee) => {
              employee.has_branch = false
            })

            branchKpi.data.forEach((branch) => {
              if (branch.user_in_charge) {
                let employee = kpichart.data.find((employee) => {
                  return employee.person_uid === branch.user_in_charge.person_uid
                })

                if (employee) {
                  employee.has_branch = true
                  employee.kpi_targets = branch.kpi_targets
                  employee.branch_uid = branch.branch_uid
                  employee.branch_name = branch.branch_name
                }
              }
            })
          
            if (!this.selectedKpiType) {
              this.selectedKpiType = this.kpiTypes[0]
            }

            this.defaultChartData = this.processKpiChartData(kpichart)
            this.updateChartData()
          }))          
      },
      processKpiChartData (res) {
        let temp = []
        this.employeeNames = []

        res.data.forEach((employee) => {
          this.employeeNames.push({   
            employee_uid: employee.employee_uid,
            name: employee.person_with_user_region ? employee.person_with_user_region.name.substring(0, 23) : 'No Person',
          })

          let kpitarget = []
          employee.kpi_targets.forEach((target) => { // simplify target objects
            kpitarget.push({
              value: target.value,
              kpi_category_id: target.kpi_category_id,
              month: target.month,
            })
          })

          let toAdd = { // simplify employee objects
            id: employee.employee_uid,
            employee_uid: employee.employee_uid,
            person: {
              id: employee.employee_uid,
            },
            cro_performance: (((employee || {}).person || {}).user || false) ? employee.person.user.cro_performance : [],
            report_to: employee.report_to,
            has_branch: employee.has_branch,
            branch_uid: employee.branch_uid ? employee.branch_uid : null,
            branch_name: employee.branch_name ? employee.branch_name : null,
            kpi_targets: kpitarget,
            kpi_target_feedback: employee.kpi_target_feedback,

          }

          temp.push(toAdd)
        })

        return temp
      },
    },
  }
</script>

<style lang="css" scoped>
  ::v-deep .v-card__text{
    padding-bottom:0px !important;
  }
  ::v-deep .ct-square {
    display:block;
    position:relative;
    width:100%;
    height: 160px !important;
  }

</style>
